module.exports = __webpack_public_path__ + "static/a1000x500-94a9d9fbccb080e5a97d681c0660e2ef.png";